export default {"src":"/_next/static/media/sad.eee044dd.svg","height":161,"width":160,"blurWidth":0,"blurHeight":0};